/**
 * 任务管理模块路由配置
 * 父级使用 RouteOutlet 确保子路由（如 /task/received）正确匹配，避免受限用户点击「收到的任务」404。
 */
import type { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'
import { ReceivedTasks, AssignedTasks } from '@/modules/task/views'
import RouteOutlet from '@/components/layout/RouteOutlet.vue'

const taskRoutes: RouteRecordRaw[] = [
  {
    path: 'task',
    name: 'Task',
    component: RouteOutlet,
    redirect: { name: 'ReceivedTasks' },
    meta: {
      titleKey: 'menu.task',
      title: '任务管理',
      requiresAuth: true,
      // 拥有查看 / 指派 / 完成任一任务权限即可看到「任务管理」
      permissions: [
        Permission.TASK_VIEW,
        Permission.TASK_EDIT,
        Permission.TASK_COMPLETE,
        Permission.TASK_ASSIGN,
        Permission.TASK_CREATE
      ],
      icon: 'CheckSquareOutlined'
    },
    children: [
      {
        path: 'received',
        name: 'ReceivedTasks',
        component: ReceivedTasks,
        meta: {
          titleKey: 'menu.receivedTasks',
          title: '收到的任务',
          requiresAuth: true,
          permissions: [Permission.TASK_VIEW],
          breadcrumb: true
        }
      },
      {
        path: 'assigned',
        name: 'AssignedTasks',
        component: AssignedTasks,
        meta: {
          titleKey: 'menu.assignedTasks',
          title: '指派的任务',
          requiresAuth: true,
          permissions: [Permission.TASK_ASSIGN],
          breadcrumb: true
        }
      },
      {
        path: 'lesson-review/:taskId',
        name: 'TaskLessonReview',
        component: () => import('@/modules/teaching/views/lesson-review.vue'),
        meta: {
          titleKey: 'menu.taskLessonReview',
          title: '教案校验',
          requiresAuth: true,
          permissions: [Permission.TASK_VIEW],
          hidden: true,
          breadcrumb: true,
        },
      },
    ]
  }
]

export default taskRoutes

